export default __webpack_public_path__ + "static/consumer-lamp-drag-f9dbeb238cae04e73608f380aaa5dd20.gif";